import {CelestialBodyType, CelestialBody} from '../scene.model';

export const METIS: CelestialBody = {
  id: 'metis',
  position: {
    x: 0,
    y: 0
  },
  mass: 3.6e16,
  radius: 21.5,
  semiMajorAxis: 128852,
  eccentricity: 0.0077,
  trueAnomaly: 0,
  meanAnomaly: 276.047,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ADRASTEA: CelestialBody = {
  id: 'adrastea',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.2e16,
  radius: 8.2,
  semiMajorAxis: 129000,
  eccentricity: 0.0063,
  trueAnomaly: 0,
  meanAnomaly: 135.673,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const AMALTHEA: CelestialBody = {
  id: 'amalthea',
  position: {
    x: 0,
    y: 0
  },
  mass: 208e16,
  radius: 83.5,
  semiMajorAxis: 181366,
  eccentricity: 0.0075,
  trueAnomaly: 0,
  meanAnomaly: 185.194,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const THEBE: CelestialBody = {
  id: 'thebe',
  position: {
    x: 0,
    y: 0
  },
  mass: 43e16,
  radius: 49.3,
  semiMajorAxis: 222452,
  eccentricity: 0.0180,
  trueAnomaly: 0,
  meanAnomaly: 135.956,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const IO: CelestialBody = {
  id: 'io',
  position: {
    x: 0,
    y: 0
  },
  mass: 8931900e16,
  radius: 1821.6,
  semiMajorAxis: 421700,
  eccentricity: 0.0041,
  trueAnomaly: 0,
  meanAnomaly: 342.021,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const EUROPA: CelestialBody = {
  id: 'europa',
  position: {
    x: 0,
    y: 0
  },
  mass: 4800000e16,
  radius: 1560.8,
  semiMajorAxis: 671034,
  eccentricity: 0.0094,
  trueAnomaly: 0,
  meanAnomaly: 171.016,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const GANYMEDE: CelestialBody = {
  id: 'ganymede',
  position: {
    x: 0,
    y: 0
  },
  mass: 14819000e16,
  radius: 2631.2,
  semiMajorAxis: 1070412,
  eccentricity: 0.0011,
  trueAnomaly: 0,
  meanAnomaly: 317.540,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const CALLISTO: CelestialBody = {
  id: 'callisto',
  position: {
    x: 0,
    y: 0
  },
  mass: 10759000e16,
  radius: 2410.3,
  semiMajorAxis: 1882709,
  eccentricity: 0.0074,
  trueAnomaly: 0,
  meanAnomaly: 181.408,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const THEMISTO: CelestialBody = {
  id: 'themisto',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.069e16,
  radius: 4.5,
  semiMajorAxis: 7405000,
  eccentricity: 0.2424,
  trueAnomaly: 0,
  meanAnomaly: 313.051,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const LEDA: CelestialBody = {
  id: 'leda',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.6e16,
  radius: 10.75,
  semiMajorAxis: 11196000,
  eccentricity: 0.1648,
  trueAnomaly: 0,
  meanAnomaly: 230.352,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ERSA: CelestialBody = {
  id: 'ersa',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0045e16,
  radius: 1.5,
  semiMajorAxis: 11348700,
  eccentricity: 0.1043,
  trueAnomaly: 0,
  meanAnomaly: 356.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PANDIA: CelestialBody = {
  id: 'pandia',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0045e16,
  radius: 1.5,
  semiMajorAxis: 11462300,
  eccentricity: 0.2084,
  trueAnomaly: 0,
  meanAnomaly: 282.4,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HIMALIA: CelestialBody = {
  id: 'himalia',
  position: {
    x: 0,
    y: 0
  },
  mass: 420e16,
  radius: 69.8,
  semiMajorAxis: 11497400,
  eccentricity: 0.1510,
  trueAnomaly: 0,
  meanAnomaly: 66.874,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const LYSITHEA: CelestialBody = {
  id: 'lysithea',
  position: {
    x: 0,
    y: 0
  },
  mass: 6.3e16,
  radius: 21.1,
  semiMajorAxis: 11628300,
  eccentricity: 0.1377,
  trueAnomaly: 0,
  meanAnomaly: 330.475,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ELARA: CelestialBody = {
  id: 'elara',
  position: {
    x: 0,
    y: 0
  },
  mass: 87e16,
  radius: 39.95,
  semiMajorAxis: 11671600,
  eccentricity: 0.2079,
  trueAnomaly: 0,
  meanAnomaly: 330.985,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const DIA: CelestialBody = {
  id: 'dia',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 12304900,
  eccentricity: 0.2606,
  trueAnomaly: 0,
  meanAnomaly: 169.9,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const CARPO: CelestialBody = {
  id: 'carpo',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0045e16,
  radius: 1.5,
  semiMajorAxis: 17151800,
  eccentricity: 0.4967,
  trueAnomaly: 0,
  meanAnomaly: 337.062,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const VALETUDO: CelestialBody = {
  id: 'valetudo',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.00015e16,
  radius: 0.5,
  semiMajorAxis: 18819000,
  eccentricity: 0.2018,
  trueAnomaly: 0,
  meanAnomaly: 201.41718,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const EUPORIE: CelestialBody = {
  id: 'euporie',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 19593900,
  eccentricity: 0.1402,
  trueAnomaly: 0,
  meanAnomaly: 70.243,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const EUPHEME: CelestialBody = {
  id: 'eupheme',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 20126300,
  eccentricity: 0.4104,
  trueAnomaly: 0,
  meanAnomaly: 168.7,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2003_J_18: CelestialBody = {
  id: 's_2003-j-18',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 20348800,
  eccentricity: 0.0465,
  trueAnomaly: 0,
  meanAnomaly: 202.160,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2010_J_2: CelestialBody = {
  id: 's_2010-j-2',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.00015e16,
  radius: 0.5,
  semiMajorAxis: 20436700,
  eccentricity: 0.3403,
  trueAnomaly: 0,
  meanAnomaly: 312.074,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HELIKE: CelestialBody = {
  id: 'helike',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 20479500,
  eccentricity: 0.1331,
  trueAnomaly: 0,
  meanAnomaly: 43.659,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2003_J_16: CelestialBody = {
  id: 's_2003-j-16',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 20512500,
  eccentricity: 0.3331,
  trueAnomaly: 0,
  meanAnomaly: 307.563,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2003_J_2: CelestialBody = {
  id: 's_2003-j-2',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 20554400,
  eccentricity: 0.2777,
  trueAnomaly: 0,
  meanAnomaly: 237.932,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const EUANTHE: CelestialBody = {
  id: 'euanthe',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0045e16,
  radius: 1.5,
  semiMajorAxis: 20583300,
  eccentricity: 0.1096,
  trueAnomaly: 0,
  meanAnomaly: 333.101,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2017_J_7: CelestialBody = {
  id: 's_2017-j-7',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 20600100,
  eccentricity: 0.2626,
  trueAnomaly: 0,
  meanAnomaly:  236.9,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HERMIPPE: CelestialBody = {
  id: 'hermippe',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 20666200,
  eccentricity: 0.1981,
  trueAnomaly: 0,
  meanAnomaly: 131.854,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PRAXIDIKE: CelestialBody = {
  id: 'praxidike',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.043e16,
  radius: 3.5,
  semiMajorAxis: 20682900,
  eccentricity: 0.2959,
  trueAnomaly: 0,
  meanAnomaly: 117.480,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const THYONE: CelestialBody = {
  id: 'thyone',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 20712800,
  eccentricity: 0.1770,
  trueAnomaly: 0,
  meanAnomaly: 238.786,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const THELXINOE: CelestialBody = {
  id: 'thelxinoe',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 20893300,
  eccentricity: 0.1709,
  trueAnomaly: 0,
  meanAnomaly: 268.013,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2017_J_3: CelestialBody = {
  id: 's_2017-j-3',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 20976900,
  eccentricity: 0.1907,
  trueAnomaly: 0,
  meanAnomaly: 91.2,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ANANKE: CelestialBody = {
  id: 'ananke',
  position: {
    x: 0,
    y: 0
  },
  mass: 3.0e16,
  radius: 14.55,
  semiMajorAxis: 21042500,
  eccentricity: 0.1747,
  trueAnomaly: 0,
  meanAnomaly: 253.384,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const MNEME: CelestialBody = {
  id: 'mneme',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 21064100,
  eccentricity: 0.3428,
  trueAnomaly: 0,
  meanAnomaly: 256.860,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2016_J_1: CelestialBody = {
  id: 's_2016-j-1',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.00015e16,
  radius: 0.5,
  semiMajorAxis: 21154000,
  eccentricity: 0.1294,
  trueAnomaly: 0,
  meanAnomaly:  25.53,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ORTHOSIE: CelestialBody = {
  id: 'orthosie',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 21171000,
  eccentricity: 0.4838,
  trueAnomaly: 0,
  meanAnomaly: 204.517,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HARPALYKE: CelestialBody = {
  id: 'harpalyke',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 21280200,
  eccentricity: 0.1602,
  trueAnomaly: 0,
  meanAnomaly: 215.956,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const IOCASTE: CelestialBody = {
  id: 'iocaste',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.019e16,
  radius: 2.5,
  semiMajorAxis: 21431800,
  eccentricity: 0.3295,
  trueAnomaly: 0,
  meanAnomaly: 213.675,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2017_J_9: CelestialBody = {
  id: 's_2017-j-9',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0045e16,
  radius: 1.5,
  semiMajorAxis: 21492900,
  eccentricity: 0.2524,
  trueAnomaly: 0,
  meanAnomaly: 259.5,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2003_J_12: CelestialBody = {
  id: 's_2003-j-12',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.00015e16,
  radius: 0.5,
  semiMajorAxis: 21557700,
  eccentricity: 0.3657,
  trueAnomaly: 0,
  meanAnomaly: 38.543,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2003_J_4: CelestialBody = {
  id: 's_2003-j-4',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 22048600,
  eccentricity: 0.4967,
  trueAnomaly: 0,
  meanAnomaly: 260.480,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ERINOME: CelestialBody = {
  id: 'erinome',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0045e16,
  radius: 1.5,
  semiMajorAxis: 22354300,
  eccentricity: 0.2052,
  trueAnomaly: 0,
  meanAnomaly: 267.136,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const AITNE: CelestialBody = {
  id: 'aitne',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0045e16,
  radius: 1.5,
  semiMajorAxis: 22386500,
  eccentricity: 0.3150,
  trueAnomaly: 0,
  meanAnomaly: 105.000,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HERSE: CelestialBody = {
  id: 'herse',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 22408800,
  eccentricity: 0.1854,
  trueAnomaly: 0,
  meanAnomaly: 141.667,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const TAYGETE: CelestialBody = {
  id: 'taygete',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.016e16,
  radius: 2.5,
  semiMajorAxis: 22433500,
  eccentricity: 0.3257,
  trueAnomaly: 0,
  meanAnomaly: 94.756,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2017_J_2: CelestialBody = {
  id: 's_2017-j-2',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 22472900,
  eccentricity: 0.3852,
  trueAnomaly: 0,
  meanAnomaly: 344.4,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2017_J_6: CelestialBody = {
  id: 's_2017-j-6',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 22543800,
  eccentricity: 0.3226,
  trueAnomaly: 0,
  meanAnomaly: 236.9,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const EUKELADE: CelestialBody = {
  id: 'eukelade',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 22576700,
  eccentricity: 0.2790,
  trueAnomaly: 0,
  meanAnomaly: 204.846,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const CARME: CelestialBody = {
  id: 'carme',
  position: {
    x: 0,
    y: 0
  },
  mass: 13e16,
  radius: 23.35,
  semiMajorAxis: 22579900,
  eccentricity: 0.2295,
  trueAnomaly: 0,
  meanAnomaly: 233.375,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2003_J_19: CelestialBody = {
  id: 's_2003-j-19',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 22752500,
  eccentricity: 0.2928,
  trueAnomaly: 0,
  meanAnomaly: 223.035,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ISONOE: CelestialBody = {
  id: 'isonoe',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 22776700,
  eccentricity: 0.2159,
  trueAnomaly: 0,
  meanAnomaly: 124.941,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2003_J_10: CelestialBody = {
  id: 's_2003-j-10',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 22896200,
  eccentricity: 0.2066,
  trueAnomaly: 0,
  meanAnomaly: 258.937,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const AUTONOE: CelestialBody = {
  id: 'autonoe',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 22933400,
  eccentricity: 0.4290,
  trueAnomaly: 0,
  meanAnomaly: 142.035,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PHILOPHROSYNE: CelestialBody = {
  id: 'philophrosyne',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 22939900,
  eccentricity: 0.3013,
  trueAnomaly: 0,
  meanAnomaly: 161.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const CYLLENE: CelestialBody = {
  id: 'cyllene',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 22965200,
  eccentricity: 0.6079,
  trueAnomaly: 0,
  meanAnomaly: 128.345,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PASITHEE: CelestialBody = {
  id: 'pasithee',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 22967800,
  eccentricity: 0.2097,
  trueAnomaly: 0,
  meanAnomaly: 215.443,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2010_J_1: CelestialBody = {
  id: 's_2010-j-1',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 22986900,
  eccentricity: 0.2937,
  trueAnomaly: 0,
  meanAnomaly: 160.525,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PASIPHAE: CelestialBody = {
  id: 'pasiphae',
  position: {
    x: 0,
    y: 0
  },
  mass: 30e16,
  radius: 28.9,
  semiMajorAxis: 23119300,
  eccentricity: 0.4362,
  trueAnomaly: 0,
  meanAnomaly: 279.769,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SPONDE: CelestialBody = {
  id: 'sponde',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 23146500,
  eccentricity: 0.3455,
  trueAnomaly: 0,
  meanAnomaly: 174.044,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2017_J_8: CelestialBody = {
  id: 's_2017-j-8',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.00015e16,
  radius: 0.5,
  semiMajorAxis: 23173700,
  eccentricity: 0.2039,
  trueAnomaly: 0,
  meanAnomaly: 70.8,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const EURYDOME: CelestialBody = {
  id: 'eurydome',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0045e16,
  radius: 1.5,
  semiMajorAxis: 23214500,
  eccentricity: 0.2975,
  trueAnomaly: 0,
  meanAnomaly: 287.689,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2017_J_5: CelestialBody = {
  id: 's_2017-j-5',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 23352500,
  eccentricity: 0.2460,
  trueAnomaly: 0,
  meanAnomaly: 77.5,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const KALYKE: CelestialBody = {
  id: 'kalyke',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.04e16,
  radius: 3.45,
  semiMajorAxis: 23377400,
  eccentricity: 0.2660,
  trueAnomaly: 0,
  meanAnomaly: 255.702,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HEGEMONE: CelestialBody = {
  id: 'hegemone',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0045e16,
  radius: 1.5,
  semiMajorAxis: 23422300,
  eccentricity: 0.3358,
  trueAnomaly: 0,
  meanAnomaly: 236.950,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const KALE: CelestialBody = {
  id: 'kale',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 23512200,
  eccentricity: 0.2893,
  trueAnomaly: 0,
  meanAnomaly: 212.853,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const KALLICHORE: CelestialBody = {
  id: 'kallichore',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 23552900,
  eccentricity: 0.3183,
  trueAnomaly: 0,
  meanAnomaly: 55.937,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2011_J_1: CelestialBody = {
  id: 's_2011-j-1',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 23714400,
  eccentricity: 0.3193,
  trueAnomaly: 0,
  meanAnomaly: 256.027,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2017_J_1: CelestialBody = {
  id: 's_2017-j-1',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 23753600,
  eccentricity: 0.4500,
  trueAnomaly: 0,
  meanAnomaly: 161.3,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const CHALDENE: CelestialBody = {
  id: 'chaldene',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 23848300,
  eccentricity: 0.2705,
  trueAnomaly: 0,
  meanAnomaly: 267.454,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const ARCHE: CelestialBody = {
  id: 'arche',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0045e16,
  radius: 1.5,
  semiMajorAxis: 23926500,
  eccentricity: 0.2367,
  trueAnomaly: 0,
  meanAnomaly: 39.713,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const EIRENE: CelestialBody = {
  id: 'eirene',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 23934500,
  eccentricity: 0.2413,
  trueAnomaly: 0,
  meanAnomaly: 284.4,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const KORE: CelestialBody = {
  id: 'kore',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 23999700,
  eccentricity: 0.2347,
  trueAnomaly: 0,
  meanAnomaly: 33.416,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2011_J_2: CelestialBody = {
  id: 's_2011-j-2',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.00015e16,
  radius: 0.5,
  semiMajorAxis: 24114700,
  eccentricity: 0.1729,
  trueAnomaly: 0,
  meanAnomaly: 285.597,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2003_J_9: CelestialBody = {
  id: 's_2003-j-9',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.00015e16,
  radius: 0.5,
  semiMajorAxis: 24168700,
  eccentricity: 0.1702,
  trueAnomaly: 0,
  meanAnomaly: 348.415,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const MEGACLITE: CelestialBody = {
  id: 'megaclite',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.021e16,
  radius: 2.5,
  semiMajorAxis: 24212300,
  eccentricity: 0.3139,
  trueAnomaly: 0,
  meanAnomaly: 135.272,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const AOEDE: CelestialBody = {
  id: 'aoede',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.009e16,
  radius: 2,
  semiMajorAxis: 24283000,
  eccentricity: 0.3131,
  trueAnomaly: 0,
  meanAnomaly: 197.676,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2003_J_23: CelestialBody = {
  id: 's_2003-j-23',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.0015e16,
  radius: 1,
  semiMajorAxis: 24678200,
  eccentricity: 0.3208,
  trueAnomaly: 0,
  meanAnomaly: 144.222,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const CALLIRRHOE: CelestialBody = {
  id: 'callirrhoe',
  position: {
    x: 0,
    y: 0
  },
  mass: 0.087e16,
  radius: 4.8,
  semiMajorAxis: 24692400,
  eccentricity: 0.3562,
  trueAnomaly: 0,
  meanAnomaly: 107.962,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SINOPE: CelestialBody = {
  id: 'sinope',
  position: {
    x: 0,
    y: 0
  },
  mass: 7.5e16,
  radius: 17.5,
  semiMajorAxis: 24864100,
  eccentricity: 0.1669,
  trueAnomaly: 0,
  meanAnomaly: 165.352,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2018_J_4: CelestialBody = {
  id: 's_2018-j-4',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.00042e16,
  radius: 1,
  semiMajorAxis: 16328500,
  eccentricity: 0.177,
  trueAnomaly: 0,
  meanAnomaly: 307.484673,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2021_J_3: CelestialBody = {
  id: 's_2021-j-3',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.00042e16,
  radius: 1,
  semiMajorAxis: 20776700,
  eccentricity: 0.239,
  trueAnomaly: 0,
  meanAnomaly: 64.69138,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2022_J_3: CelestialBody = {
  id: 's_2022-j-3',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.000052e16,
  radius: 0.5,
  semiMajorAxis: 20912400,
  eccentricity: 0.272,
  trueAnomaly: 0,
  meanAnomaly: 77.88890,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2021_J_2: CelestialBody = {
  id: 's_2021-j-2',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.000052e16,
  radius: 0.5,
  semiMajorAxis: 20926600,
  eccentricity: 0.242,
  trueAnomaly: 0,
  meanAnomaly: 320.08120,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2021_J_1: CelestialBody = {
  id: 's_2021-j-1',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.000052e16,
  radius: 0.5,
  semiMajorAxis: 20954700,
  eccentricity: 0.228,
  trueAnomaly: 0,
  meanAnomaly: 312.94753,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2022_J_1: CelestialBody = {
  id: 's_2022-j-1',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.000052e16,
  radius: 0.5,
  semiMajorAxis: 22015500,
  eccentricity: 0.191,
  trueAnomaly: 0,
  meanAnomaly: 330.01243,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2022_J_2: CelestialBody = {
  id: 's_2022-j-2',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.000052e16,
  radius: 0.5,
  semiMajorAxis: 22413200,
  eccentricity: 0.182,
  trueAnomaly: 0,
  meanAnomaly: 257.85858,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2016_J_3: CelestialBody = {
  id: 's_2016-j-3',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.00042e16,
  radius: 1,
  semiMajorAxis: 22719300,
  eccentricity: 0.251,
  trueAnomaly: 0,
  meanAnomaly: 1.36683,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2021_J_6: CelestialBody = {
  id: 's_2021-j-6',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.000052e16,
  radius: 0.5,
  semiMajorAxis: 22870300,
  eccentricity: 0.271,
  trueAnomaly: 0,
  meanAnomaly: 77.36574,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2021_J_4: CelestialBody = {
  id: 's_2021-j-4',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.000052e16,
  radius: 0.5,
  semiMajorAxis: 23019700,
  eccentricity: 0.265,
  trueAnomaly: 0,
  meanAnomaly: 102.76481,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2016_J_4: CelestialBody = {
  id: 's_2016-j-4',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.000052e16,
  radius: 0.5,
  semiMajorAxis: 23113800,
  eccentricity: 0.294,
  trueAnomaly: 0,
  meanAnomaly: 138.36439,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2018_J_3: CelestialBody = {
  id: 's_2018-j-3',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.000052e16,
  radius: 0.5,
  semiMajorAxis: 23400300,
  eccentricity: 0.268,
  trueAnomaly: 0,
  meanAnomaly: 16.59790,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const S_2021_J_5: CelestialBody = {
  id: 's_2021-j-5',
  position: {
    x: 0,
    y: 0
  },
  speed: 0, // TODO
  mass: 0.00042e16,
  radius: 1,
  semiMajorAxis: 23414600,
  eccentricity: 0.272,
  trueAnomaly: 0,
  meanAnomaly: 329.67857,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const JUPITER: CelestialBody = {
  id: 'jupiter',
  position: {
    x: 0,
    y: 0
  },
  speed: 13.07,
  mass: 1.8982e27,
  radius: 69911,
  semiMajorAxis: 778570000,
  eccentricity: 0.0489,
  trueAnomaly: 0,
  meanAnomaly: 20.020,
  longitudeOfAscendingNode: 100.464,
  type: CelestialBodyType.PLANET,
  satellites: [
    METIS,
    ADRASTEA,
    AMALTHEA,
    THEBE,
    IO,
    EUROPA,
    GANYMEDE,
    CALLISTO,
    THEMISTO,
    LEDA,
    ERSA,
    PANDIA,
    HIMALIA,
    LYSITHEA,
    ELARA,
    DIA,
    CARPO,
    VALETUDO,
    EUPORIE,
    EUPHEME,
    S_2003_J_18,
    S_2010_J_2,
    HELIKE,
    S_2003_J_16,
    S_2003_J_2,
    EUANTHE,
    S_2017_J_7,
    HERMIPPE,
    PRAXIDIKE,
    THYONE,
    THELXINOE,
    S_2017_J_3,
    ANANKE,
    MNEME,
    S_2016_J_1,
    ORTHOSIE,
    HARPALYKE,
    IOCASTE,
    S_2017_J_9,
    S_2003_J_12,
    S_2003_J_4,
    ERINOME,
    AITNE,
    HERSE,
    TAYGETE,
    S_2017_J_2,
    S_2017_J_6,
    EUKELADE,
    CARME,
    S_2003_J_19,
    ISONOE,
    S_2003_J_10,
    AUTONOE,
    PHILOPHROSYNE,
    CYLLENE,
    PASITHEE,
    S_2010_J_1,
    PASIPHAE,
    SPONDE,
    S_2017_J_8,
    EURYDOME,
    S_2017_J_5,
    KALYKE,
    HEGEMONE,
    KALE,
    KALLICHORE,
    S_2011_J_1,
    S_2017_J_1,
    CHALDENE,
    ARCHE,
    EIRENE,
    KORE,
    S_2011_J_2,
    S_2003_J_9,
    MEGACLITE,
    AOEDE,
    S_2003_J_23,
    CALLIRRHOE,
    SINOPE,
    S_2018_J_4,
    S_2021_J_3,
    S_2022_J_3,
    S_2021_J_2,
    S_2021_J_1,
    S_2022_J_1,
    S_2022_J_2,
    S_2016_J_3,
    S_2021_J_6,
    S_2021_J_4,
    S_2016_J_4,
    S_2018_J_3,
    S_2021_J_5
  ],
  rings: [
    { id: 'halo', radius: 92000, width: 30500, depth: 12500 },
    { id: 'main', radius: 122500, width: 6500, depth: 160 },
    { id: 'thebe_gossamer', radius: 129000, width: 97000, depth: 8400 },
    { id: 'amalthea_gossamer', radius: 129000, width: 53000, depth: 2000 }
  ],
  orbitBody: null
};

JUPITER.satellites.forEach(satellite => satellite.orbitBody = JUPITER);
